import { SxProps } from "@mui/material";

export const sxIconButton: SxProps = {
  color: '#383838',
  display: 'flex',  
  justifyContent: 'center',  
  alignItems: 'center',
  '@media (max-width: 899px)': {
    height: '60px',
  },
  width: '40px', 
  height: '40px', 
}

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#383838',
  fontWeight: 700,
  fontSize: 24,
  textAlign: 'center'
}

export const sxTypographyTitleLeft: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#383838',
  fontWeight: 700,
  fontSize: 24,
  textAlign: 'start'
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}

export const sxButtonLogin: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
}

export const sxButtonOptionRecovery: SxProps = {
  borderRadius: '80px',
  padding: '12px 32px',
  width: '100%'
}

export const sxButtonText: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  padding: 0,
  '&:hover': {
    color: '#164029',
  }
}


export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '##D84141',
  fontSize: 12
}